import ProcessoStore from '@/store/ProcessoStore';
import { Button } from '@mui/material';
import { computed, extendObservable, makeObservable } from 'mobx';
import { ConfiguracaoControleGabinete } from './ConfiguracaoControleGabinete';
import { ITipoControleGabinete, TipoControle } from './TipoControleGabinete';

export class ControleGabinete {

    static criar(partial: Partial<ControleGabinete>) {
        const controle = new ControleGabinete();

        const mobxInicial = ControleGabinete.mobxInicial();
        extendObservable(controle, mobxInicial);

        // quantidadeProcessos é computed (derivado ao vivo de ProcessoStore._processos);
        // se o backend mandar esse campo no payload, precisa ser ignorado aqui, senão
        // o MobX recusa a atribuição (computed não é gravável).
        const { quantidadeProcessos: _, ...partialSemComputados } = partial;
        const result = Object.assign(controle, partialSemComputados);
        result.configControle = ConfiguracaoControleGabinete.criar(partial.configControle);

        return result;
    }

    private constructor() {
        makeObservable(this, {
            quantidadeProcessos: computed
        });
    }

    static mobxInicial = () => ({
    })

    tipo: ITipoControleGabinete;
    descricao: string;
    numero: number;
    numeroOrdem: number;
    ativo?: boolean;

    configControle: ConfiguracaoControleGabinete;
    count?: number;
    ordem?: number;
    index?: number;

    get conteudo() {
        if (this.isTipo(TipoControle.IMPORTAR)) {
            return <Button color='secondary'>{this.tipo.descricao}</Button>;
        } else {
            return this.tipo.id + ' - ' + this.tipo.descricao;
        }
    }

    get quantidadeProcessos() {
        const count = ProcessoStore._processos.filter(proc => {
            return proc.noFluxoCerto && proc.controleGabinete?.numero == this.numero
        })?.length;
        return count || 0;
    }

    isTipo(tipo: TipoControle): boolean {
        return this.tipo.id === tipo;
    }

    isAlgumTipo(tipos: TipoControle[]) {
        return tipos.some(tipo => this.tipo.id === tipo);
    }

    regrasPossuiMinuta() {
        return this.configControle && this.configControle.regrasPossuiMinuta;
    }

    public toJSON() {
        return {
            ...this,
            index: undefined,
            // quantidadeMinutas: undefined,
            quantidadeProcessos: undefined,
            count: undefined,
            ordem: undefined
        }
    }
}
